import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['AlternativeNames'] });

const apiBrandAlternativeNamesSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getAlternativeNames: builder.query({
      query: ({ opk, id }) => ({
        url: `/community/organizations/${opk}/brands/${id}/alternative_names/`,
        method: 'GET',
      }),
      providesTags: ['AlternativeNames'],
    }),
    postAlternativeNames: builder.mutation({
      query: ({ opk, id, payload }) => ({
        url: `/community/organizations/${opk}/brands/${id}/alternative_names/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['AlternativeNames'],
    }),
    getAlternativeName: builder.query({
      query: ({ opk, bpk, id }) => ({
        url: `/community/organizations/${opk}/brands/${bpk}/alternative_names/${id}`,
        method: 'GET',
      }),
      providesTags: ['AlternativeNames'],
    }),
    putAlternativeName: builder.mutation({
      query: ({ opk, bpk, id, payload }) => ({
        url: `/community/organizations/${opk}/brands/${bpk}/alternative_names/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['AlternativeNames'],
    }),
    patchAlternativeName: builder.mutation({
      query: ({ opk, bpk, id, payload }) => ({
        url: `/community/organizations/${opk}/brands/${bpk}/alternative_names/${id}`,
        method: 'PATCH',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['AlternativeNames'],
    }),
    deleteAlternativeName: builder.mutation({
      query: ({ opk, bpk, id }) => ({
        url: `/community/organizations/${opk}/brands/${bpk}/alternative_names/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['AlternativeNames'],
    }),
  }),
});

export const { useGetAlternativeNamesQuery, usePostAlternativeNamesMutation, useGetAlternativeNameQuery, usePutAlternativeNameMutation, usePatchAlternativeNameMutation, useDeleteAlternativeNameMutation } = apiBrandAlternativeNamesSlice;

export default apiBrandAlternativeNamesSlice;
